import { mHeadMixin } from "@mixin/mHead";
export default {
  name: "cityHead",
  mixins: [mHeadMixin]
};